import { render } from "./DunningList.vue?vue&type=template&id=675a5852"
import script from "./DunningList.vue?vue&type=script&lang=js"
export * from "./DunningList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__